import { Carousel } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import truper from '../../assets/img/carrousel/TRUPER.jpg'
import fiero from '../../assets/img/carrousel/FIERO.jpg'
import foset from '../../assets/img/carrousel/FOSET.jpg'
import hermex from '../../assets/img/carrousel/HERMEX.jpg'
import klintek from '../../assets/img/carrousel/KLINTEK.jpg'
import pretul from '../../assets/img/carrousel/PRETUL.jpg'
import volteck from '../../assets/img/carrousel/VOLTECK.jpg'

function Carrousel() {
    const slides = [
        {
            image: truper,
            alt: "truper",
            title: "TRUPER",
            subtitle: "Herramientas de Calidad Profesional",
            description: "Líderes en herramientas manuales y eléctricas",
            // icon: <Award size={48} />,
            color: "#fe5000"
        },
        {
            image: pretul,
            alt: "pretul",
            title: "PRETUL",
            subtitle: "Productos Caseros",
            description: "Disenados para uso ligero y laborales en el hogar",
            // icon: <TrendingUp size={48} />,
            color: "#fe5000"
        },
        {
            image: foset,
            alt: "foset",
            title: "FOSET",
            subtitle: "Griferia y Plomeria",
            description: "Con sus 5 lineas que cubren todas las necesidades",
            // icon: <Star size={48} />,
            color: "#fe5000"
        },
        {
            image: volteck,
            alt: "volteck",
            title: "VOLTECK",
            subtitle: "Productos Electricos",
            description: "Para todo el mercado ferretero",
            // icon: <Star size={48} />,
            color: "#fe5000"
        },
        {
            image: fiero,
            alt: "fiero",
            title: "FIERO",
            subtitle: "Productos de Acero",
            description: "Para toda la industria ferretera",
            // icon: <Award size={48} />,
            color: "#fe5000"
        },
        {
            image: hermex,
            alt: "hermex",
            title: "HERMEX",
            subtitle: "Cerrajeria",
            description: "Con la mas alta calidad y diseno",
            // icon: <Star size={48} />,
            color: "#fe5000"
        },
        {
            image: klintek,
            alt: "klintek",
            title: "KLINTEK",
            subtitle: "Articulos de Limpieza",
            description: "Articulos para casa y oficina",
            // icon: <TrendingUp size={48} />,
            color: "#fe5000"
        }
    ];

    return (
        <div className="carousel-container-modern">
            <Carousel 
                fade 
                interval={4000} 
                controls={true}
                indicators={true}
                prevIcon={
                    <div className="carousel-control-custom prev">
                        <ChevronLeft size={32} />
                    </div>
                }
                nextIcon={
                    <div className="carousel-control-custom next">
                        <ChevronRight size={32} />
                    </div>
                }
            >
                {slides.map((slide, index) => (
                    <Carousel.Item key={index}>
                        <div className="carousel-item-wrapper">
                            {/* Imagen de fondo */}
                            <img
                                className="d-block w-100 carousel-image"
                                src={slide.image}
                                alt={slide.alt}
                            />
                            
                            {/* Overlay oscuro con gradiente */}
                            <div className="carousel-overlay"></div>
                            
                            {/* Contenido del slide */}
                            <Carousel.Caption className="carousel-caption-modern">
                                <div className="caption-content">
                                    {/* Icono animado */}
                                    <div className="caption-icon" style={{ color: slide.color }}>
                                        {slide.icon}
                                    </div>
                                    
                                    {/* Título principal */}
                                    {/* <h1 className="caption-title">
                                        {slide.title}
                                    </h1>
                                     */}
                                    {/* Línea decorativa */}
                                    {/* <div className="caption-divider" style={{ backgroundColor: slide.color }}></div> */}
                                    
                                    {/* Subtítulo */}
                                    <h2 className="caption-subtitle">
                                        {slide.subtitle}
                                    </h2>
                                    
                                    {/* Descripción */}
                                    <p className="caption-description">
                                        {slide.description}
                                    </p>
                                    
                                    {/* Botones de acción */}
                                    {/* <div className="caption-buttons">
                                        <a 
                                            href="/showroom" 
                                            className="btn-carousel-primary"
                                            style={{ backgroundColor: slide.color }}
                                        >
                                            Ver Productos
                                        </a>
                                        <a 
                                            href="/contacto" 
                                            className="btn-carousel-secondary"
                                        >
                                            Contactar
                                        </a>
                                    </div> */}
                                </div>
                            </Carousel.Caption>
                            
                            {/* Indicador de número de slide */}
                            <div className="slide-number">
                                <span className="current-slide">{String(index + 1).padStart(2, '0')}</span>
                                <span className="slide-separator">/</span>
                                <span className="total-slides">{String(slides.length).padStart(2, '0')}</span>
                            </div>
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>
            
            {/* Scroll indicator */}
            <div className="scroll-indicator">
                <div className="mouse-icon">
                    <div className="mouse-wheel"></div>
                </div>
                <span className="scroll-text">Desliza para explorar</span>
            </div>
        </div>
    );
}

export default Carrousel;